<template>
  <md-button
    class="md-primary join-event-button"
    @click="goToJoinEvent"
  >
    Login to Enter KAB20 Experience
  </md-button>
</template>

<script>
export default {
  name: "JoinEventButton",
  methods: {
    goToJoinEvent () {
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.join-event-button {
  width: 258px !important;
  height: 44px;
  margin-left: 0px;
  background-color: $color-primary !important;
  color: $color-white !important;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500; 
  text-align: center;
  background-image: linear-gradient(to left, #a30078, #6a0043);
}
</style>
